<template>
  <div>
    <NavigationBar titel="Kalender" :actions="actions"></NavigationBar>
    <section>
      <TippCard
        hintID="Terminplanung_Kalender_1_V1"
        text="Im Kalender werden Veranstaltungen und eingetragene Termine angezeigt. Verschiedene Ansichten lassen vorausschauend planen."
      >
      </TippCard>
    </section>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="center">
            <!-- Sidebar for event type filters -->
            <v-col v-if="sidebarOpen" cols="12" md="3" lg="2" class="pr-0">
              <v-card height="800px" class="overflow-y-auto">
                <!-- <v-card-title class="text-subtitle-1 pb-2">
                  <v-icon left small>mdi-filter-variant</v-icon>
                  Filter
                </v-card-title>
                <v-divider></v-divider> -->

                <!-- Event Types Section -->
                <v-card-text class="pb-0">
                  <div class="d-flex justify-space-between align-center">
                    <span class="text-subtitle-2 font-weight-bold"
                      >Veranstaltungsarten</span
                    >
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on">
                          <v-icon small>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense nav>
                        <v-list-item @click="toggleAllEventTypes(true)">
                          <v-list-item-title>Alle auswählen</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="toggleAllEventTypes(false)">
                          <v-list-item-title>Alle abwählen</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-card-text>
                <v-card-text class="pt-0 pb-2 px-0">
                  <v-list dense nav>
                    <v-list-item
                      v-for="eventType in eventTypes"
                      :key="eventType.meta.id"
                      @click="toggleEventType(eventType.meta.id)"
                      class="my-0"
                    >
                      <v-list-item-action class="mr-2 my-0">
                        <v-checkbox
                          :input-value="
                            selectedEventTypeIds.has(eventType.meta.id)
                          "
                          dense
                          hide-details
                          @click.stop="toggleEventType(eventType.meta.id)"
                          class="my-0"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content class="py-0">
                        <event-type-chip
                          :eventType="eventType"
                          :small="true"
                        ></event-type-chip>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>

                <!-- <v-divider ></v-divider> -->

                <!-- Additional Calendar Items Section -->
                <!-- <v-card-text class="pb-0">
                  <div class="text-subtitle-2 font-weight-bold">
                    Weitere Elemente
                  </div>
                </v-card-text>
                <v-card-text class="pt-0 pb-2 px-0">
                  <v-list dense nav>
                    <v-list-item
                      v-for="(item, key) in additionalCalendarItems"
                      :key="key"
                      @click="toggleAdditionalItem(key)"
                      class="my-0"
                    >
                      <v-list-item-action class="mr-2 my-0">
                        <v-checkbox
                          :input-value="item.enabled"
                          dense
                          hide-details
                          @click.stop="toggleAdditionalItem(key)"
                          class="py-0"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content class="py-0">
                        <v-chip
                          small
                          label
                          :color="item.color"
                          text-color="white"
                          class="font-weight-medium"
                        >
                          {{ item.title }}
                        </v-chip>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text> -->
              </v-card>
            </v-col>

            <!-- Main calendar view -->
            <v-col
              cols="12"
              :md="sidebarOpen ? 9 : 12"
              :lg="sidebarOpen ? 10 : 12"
            >
              <v-card height="800px" class="overflow-hidden">
                <v-toolbar height="64" outlined flat>
                  <v-btn outlined small @click="prev" class="ml-2 mr-2">
                    <v-icon dense>mdi-chevron-left</v-icon>
                  </v-btn>
                  <v-btn outlined small @click="next" class="mr-4">
                    <v-icon dense>mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ calendarTitle }}</v-toolbar-title>
                  <div class="flex-grow-1"></div>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="
                          $store.state.organization.activeOrganization.config
                            .scheduling.showAllEventsInList ||
                          checkIfSupport ||
                          checkIfItService
                        "
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        class="mr-4"
                      >
                        <span>
                          <v-icon left small>mdi-calendar-filter</v-icon>
                          {{ eventsFilter }}
                        </span>
                        <v-icon right>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list nav>
                      <v-list-item-group v-model="eventsFilter" mandatory>
                        <v-list-item link dense value="Alle">
                          <v-list-item-icon>
                            <v-icon dense>mdi-all-inclusive</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Alle Veranstaltungen anzeigen</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item link dense value="Eigene">
                          <v-list-item-icon>
                            <v-icon dense>mdi-filter</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Nur eigene Veranstaltungen</v-list-item-title
                          >
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-menu>
                  <v-btn outlined class="mr-4" @click="setToday"> Heute </v-btn>
                  <v-menu offset-y bottom right>
                    <template v-slot:activator="{ on }">
                      <v-btn outlined v-on="on">
                        <span>{{ typeToLabel[type] }}</span>
                        <v-icon right>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list nav dense>
                      <v-list-item @click="type = 'day'">
                        <v-list-item-title>Tag</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'week'">
                        <v-list-item-title>Woche</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'month'">
                        <v-list-item-title>Monat</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = '4day'">
                        <v-list-item-title>4 Tage</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item @click="type = 'category'">
                        <v-list-item-title>Kategorie</v-list-item-title>
                      </v-list-item> -->
                    </v-list>
                  </v-menu>
                </v-toolbar>
                <v-calendar
                  ref="calendar"
                  v-model="value"
                  color="primary"
                  :events="filteredEvents"
                  locale="de"
                  locale-first-day-of-year="4"
                  show-week
                  show-month-on-first
                  :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                  :short-weekdays="calShortWeekdays"
                  :short-months="calShortMonths"
                  event-name="title"
                  :event-margin-bottom="3"
                  :now="today"
                  :type="type"
                  event-category="type.title"
                  :event-color="getEventColor"
                  :event-text-color="getEventTextColor"
                  @click:event="showEvent"
                  @click:more="viewDay"
                  @click:date="viewDay"
                  @change="updateRange"
                >
                  <template v-slot:day-body="{ date, week }">
                    <div
                      class="v-current-time"
                      :class="{ first: date === week[0].date }"
                      :style="{ top: nowY }"
                    ></div>
                  </template>
                </v-calendar>
                <v-menu
                  v-model="selectedOpen"
                  :close-on-content-click="false"
                  :activator="selectedElement"
                  max-width="650px"
                  offset-x
                >
                  <event-details-card
                    :event="selectedEvent"
                    showCloseButton
                    showDetailsButton
                    minWidth="440px"
                    maxWidth="500px"
                    @closeEvent="selectedOpen = false"
                  ></event-details-card>
                </v-menu>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import EventDetailsCard from "@/components/scheduling/EventDetailsCard.vue";
import EventTypeChip from "@/components/scheduling/EventTypeChip.vue";
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import { SCHEDULING } from "@/store/modules.js";
import { GET_EVENTS, GET_EVENT_TYPES } from "@/store/action-types.js";
import { SCHEDULING_CALENDAR_FEEDS_read } from "@/data/permission-types.js";
import { getMaterialColor } from "@/util/styles";
import vuetifyColors from "vuetify/lib/util/colors";

export default {
  name: "scheduling-calendar",
  components: {
    NavigationBar,
    TippCard,
    SupportTools,
    EventDetailsCard,
    EventTypeChip,
  },
  data() {
    return {
      actions: [
        {
          title: "Kalenderfeeds",
          permission: `${SCHEDULING_CALENDAR_FEEDS_read}`,
          icon: "mdi-rss",
          actionStyle: "textBtn",
          function: () => {
            this.$router.push({ name: "scheduling-calendar-feeds" });
          },
        },
      ],
      eventsFilter: "Eigene",
      today: new Date().toISOString().substr(0, 10),
      focus: new Date().toISOString().substr(0, 10),
      type: "month",
      value: "",
      ready: false,
      typeToLabel: {
        month: "Monat",
        week: "Woche",
        day: "Tag",
        "4day": "4 Tage",
        // "category": "Kategorien"
      },
      title: null,
      start: null,
      end: null,
      color: "#1976D2", // default event color
      selectedEvent: null,
      selectedElement: null,
      selectedOpen: false,
      calShortMonths: false,
      calShortWeekdays: false,
      // Sidebar and filtering
      sidebarOpen: true,
      selectedEventTypeIds: new Set(),
      // Additional calendar items (holidays, special days, etc.)
      additionalCalendarItems: {
        holidays: {
          enabled: true,
          items: [], // Will be populated with holiday data
          color: "#9E9E9E",
          title: "Feiertage",
        },
        schoolHolidays: {
          enabled: true,
          items: [], // Will be populated with school holiday data
          color: "#FF9800",
          title: "Schulferien",
        },
      },
    };
  },
  computed: {
    code() {
      return [
        { title: "events", data: this.events },
        { title: "filteredEvents", data: this.filteredEvents },
        { title: "selectedEvent", data: this.selectedEvent },
        { title: "eventTypes", data: this.eventTypes },
      ];
    },
    eventTypes() {
      return this.$store.state.scheduling.eventTypes || [];
    },
    events() {
      return this.$store.state.scheduling.eventsISO;
    },
    filteredEvents() {
      // Filter events by selected event types
      const filtered = this.events.filter((event) => {
        return this.selectedEventTypeIds.has(event.type.id);
      });

      // Add additional calendar items (holidays, school holidays)
      const additionalItems = [];

      Object.keys(this.additionalCalendarItems).forEach((key) => {
        const category = this.additionalCalendarItems[key];
        if (category.enabled && category.items.length > 0) {
          additionalItems.push(...category.items);
        }
      });

      return [...filtered, ...additionalItems];
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    checkIfItService() {
      return this.$store.getters["organization/checkIfItService"];
    },
    cal() {
      return this.ready ? this.$refs.calendar : null;
    },
    nowY() {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + "px" : "-10px";
    },
    calendarTitle() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }
      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      // const suffixMonth = startMonth === endMonth ? '' : endMonth
      const startYear = start.year;
      const endYear = end.year;
      // const suffixYear = startYear === endYear ? '' : endYear
      const startDay = start.day; //+ this.nth(start.day)
      const endDay = end.day; //+ this.nth(end.day)
      switch (this.type) {
        case "month":
          return `${startMonth} ${startYear}`;
        case "week":
          return `${startDay}. ${startMonth} ${startYear} bis ${endDay}. ${endMonth} ${endYear}`;
        case "4day":
          return `${startDay}. ${startMonth} ${startYear} bis ${endDay}. ${endMonth} ${endYear}`;
        case "day":
          return `${startDay}. ${startMonth} ${startYear}`;
      }
      return "";
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long",
      });
    },
  },
  watch: {
    "$store.state.organization.activeOrganization.config.scheduling.showAllEventsInList":
      {
        immediate: true, // Execute immediately on component creation
        handler(showAllEventsInListNew) {
          // Check if showAllEventsInListNew is populated and then execute your code
          if (showAllEventsInListNew !== null && showAllEventsInListNew) {
            // this.helpers.dataIsLoading = true;

            this.$store
              .dispatch(`${SCHEDULING}${GET_EVENTS}`, {
                organizationId: this.$route.params.organizationId,
                withStatus: true,
                query: {
                  onlyOwn: false,
                },
                // withStatus: this.$store.getters["organization/checkPermissionByID"](
                //   `${SCHEDULING_EVENTS_RESPONSES_OWN_update}`
                // )
                //   ? true
                //   : false,
              })
              .then(
                () => {
                  // this.helpers.dataIsLoading = false;
                },
                (error) => {
                  console.error(error);
                }
              );
          } else {
            // this.helpers.dataIsLoading = false;
            (this.eventsFilter = "Eigene"),
              this.$store
                .dispatch(`${SCHEDULING}${GET_EVENTS}`, {
                  organizationId: this.$route.params.organizationId,
                  withStatus: true,
                  query: {
                    onlyOwn: false,
                  },
                })
                .then(
                  () => {
                    // this.helpers.dataIsLoading = false;
                  },
                  (error) => {
                    console.error(error);
                  }
                );
          }
        },
      },
  },
  mounted() {
    this.ready = true;
    this.scrollToTime();
    this.updateTime();
  },
  created() {
    this.initialize();
    this.loadEventTypes();
  },
  methods: {
    initialize() {
      if (window.outerWidth < 600) {
        this.calShortMonths = true;
        this.calShortWeekdays = true;
        this.sidebarOpen = false; // Close sidebar on mobile by default
      }
    },
    loadEventTypes() {
      // Check if event types are already loaded in store
      if (this.eventTypes.length > 0) {
        // Initialize all event types as selected
        const newSet = new Set();
        this.eventTypes.forEach((eventType) => {
          newSet.add(eventType.meta.id);
        });
        this.selectedEventTypeIds = newSet;
      }

      // Fetch event types from store
      this.$store
        .dispatch(`${SCHEDULING}${GET_EVENT_TYPES}`, {
          organizationId: this.$route.params.organizationId,
        })
        .then(() => {
          // Initialize all event types as selected
          const newSet = new Set();
          this.eventTypes.forEach((eventType) => {
            newSet.add(eventType.meta.id);
          });
          this.selectedEventTypeIds = newSet;
        })
        .catch((error) => {
          console.error("Error loading event types:", error);
        });
    },
    toggleEventType(eventTypeId) {
      if (this.selectedEventTypeIds.has(eventTypeId)) {
        this.selectedEventTypeIds.delete(eventTypeId);
      } else {
        this.selectedEventTypeIds.add(eventTypeId);
      }
      // Trigger reactivity
      this.selectedEventTypeIds = new Set(this.selectedEventTypeIds);
    },
    toggleAllEventTypes(select = true) {
      if (select) {
        this.eventTypes.forEach((eventType) => {
          this.selectedEventTypeIds.add(eventType.meta.id);
        });
      } else {
        this.selectedEventTypeIds.clear();
      }
      // Trigger reactivity
      this.selectedEventTypeIds = new Set(this.selectedEventTypeIds);
    },
    toggleAdditionalItem(key) {
      if (this.additionalCalendarItems[key]) {
        this.additionalCalendarItems[key].enabled =
          !this.additionalCalendarItems[key].enabled;
      }
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },

    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getCurrentTime() {
      return this.cal
        ? this.cal.times.now.hour * 60 + this.cal.times.now.minute
        : 0;
    },
    scrollToTime() {
      const time = this.getCurrentTime();
      const first = Math.max(0, time - (time % 30) - 30);

      this.cal.scrollToTime(first);
    },
    updateTime() {
      setInterval(() => this.cal.updateTimes(), 60 * 1000);
    },
    getEventColor(event) {
      // Return light background color matching the DataChip style
      const baseColor = event.type?.color || event.color || "#9E9E9E";
      const colorName = getMaterialColor(baseColor, { output: "word" });

      if (colorName) {
        // Convert kebab-case to camelCase (e.g., "deep-purple" -> "deepPurple")
        const camelCaseName = colorName.replace(/-([a-z])/g, (g) =>
          g[1].toUpperCase()
        );

        if (vuetifyColors[camelCaseName]) {
          // Return the lighten-4 shade for light background
          return (
            vuetifyColors[camelCaseName].lighten4 ||
            vuetifyColors[camelCaseName].base
          );
        }
      }
      return baseColor;
    },
    getEventTextColor(event) {
      // Return dark text color matching the DataChip style (darken-4)
      const baseColor = event.type?.color || event.color || "#9E9E9E";
      const colorName = getMaterialColor(baseColor, { output: "word" });

      if (colorName) {
        // Convert kebab-case to camelCase (e.g., "deep-purple" -> "deepPurple")
        const camelCaseName = colorName.replace(/-([a-z])/g, (g) =>
          g[1].toUpperCase()
        );

        if (vuetifyColors[camelCaseName]) {
          // Return the darken-4 shade for dark text
          return (
            vuetifyColors[camelCaseName].darken4 ||
            vuetifyColors[camelCaseName].base
          );
        }
      }

      return "rgba(255, 255, 255, 0.87)";
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      this.start = start;
      this.end = end;
    },
    nth(d) {
      return d;
      // return d> 3 && d < 21
      //   ? 'th'
      //   : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
    },
  },
};
</script>

<style lang="scss">
.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: "";
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}

// Style calendar events with medium font weight for consistency
.v-calendar .v-event {
  font-weight: 500 !important;
}
</style>
